import React from "react"
import PropTypes from "prop-types"

import { Link, useI18next } from "gatsby-plugin-react-i18next"

import * as languageSwitcherStyles from "../styles/LanguageSwitcher.module.css"

const isActive = process.env.GATSBY_MULTI_LANG === `true` || false

export default function LanguageSwitcher(props) {
  const { supportedLanguages } = props
  const { languages, language, originalPath } = useI18next()

  const [isOpen, setIsOpen] = React.useState(false)

  React.useEffect(() => {
    if (!props.canBeOpen) setIsOpen(false)
  }, [props.canBeOpen])

  return (
    <div
      className={languageSwitcherStyles.wrapper}
      style={{ display: isActive ? `block` : `none` }}
    >
      <a
        href="#!"
        onClick={evt => {
          evt.preventDefault()
          if (props.onToggle) props.onToggle(!isOpen)
          setIsOpen(!isOpen)
        }}
      >
        {supportedLanguages
          .filter(l => l.slug === language)[0]
          .slug.split(`_`)[1]
          .toUpperCase()}
      </a>
      <ul className={languageSwitcherStyles.languageList}>
        {isOpen &&
          props.canBeOpen &&
          languages
            .filter(lng => lng !== language)
            .map(lng => (
              <li
                key={lng}
                data-active-lang={lng === language ? "true" : "false"}
              >
                <Link to={originalPath} language={lng}>
                  {supportedLanguages
                    .filter(l => l.slug === lng)[0]
                    .slug.split(`_`)[1]
                    .toUpperCase()}
                </Link>
              </li>
            ))}
      </ul>
    </div>
  )
}

LanguageSwitcher.propTypes = {
  canBeOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func,
}
